import { useMemo } from 'react';
import { Typography } from 'iglooform';
import { history } from 'umi';
import { useIntl } from 'react-intl';
import { MailOutlined, PhoneOutlined, RightOutlined } from '@ant-design/icons';
import styles from './customerList.less';

type ListProps = {
  list: CustomerListType;
  isPc: boolean;
};

const CustomerList = (props: ListProps) => {
  const { list = [], isPc } = props;
  const selected_lang = localStorage.getItem('selected_lang');
  const { formatMessage } = useIntl();

  const customerListRender = useMemo(
    () =>
      list.map((value: any, index: any) => (
        <div
          key={index}
          className={styles.customerListH5List}
          onClick={() => {
            if (!isPc) {
              return history.push('/customers/policies?id=' + value.id);
            }
          }}
        >
          <div className={styles.customerListH5ListLeft}>
            <div
              className={styles.name}
              style={isPc ? {} : { marginBottom: 8 }}
            >
              <Typography level={'body1'}>{value.name}</Typography>
            </div>
            <div
              className={styles.email}
              style={isPc ? {} : { marginBottom: 8 }}
            >
              <MailOutlined style={{ color: '#999', fontSize: '16px' }} />{' '}
              <Typography level={'body2'}>{value.email}</Typography>
            </div>
            <div className={styles.phoneNumber}>
              <PhoneOutlined style={{ color: '#999', fontSize: '16px' }} />{' '}
              <span style={{ color: '#5858FF' }}>
                <Typography level={'body2'}>
                  {value.mobile_no?.area_code} {value.mobile_no?.phone_number}
                </Typography>
              </span>
            </div>
          </div>
          <div>
            {isPc ? (
              <span
                style={{ color: '#5858FF', cursor: 'pointer' }}
                onClick={() =>
                  history.push('/customers/policies?id=' + value.id)
                }
              >
                {formatMessage({ id: 'View Policies' })}
              </span>
            ) : (
              <RightOutlined style={{ color: '#5858FF' }} />
            )}
          </div>
        </div>
      )),
    [list, selected_lang],
  );

  return <div className={styles.customerListH5Box}>{customerListRender}</div>;
};

export default CustomerList;
